<template>
  <div class="container">
    <div id="title-of-save">
      <h1 id="title-text-child">
        Campaign: <span class="campaign-title">{{ campaignName }}</span>
      </h1>
    </div>
    <sdx-loading-spinner id="spinner-campaignEdit" size="large" sr-hint="Loading. Please wait."></sdx-loading-spinner>
    <!--
    <div class="row margin-bottom-2">
      <div class="col">
        <span class="sdx-like-label" style="padding-right: 5px">Tag</span>
        <sdx-menu-flyout>
          <sdx-menu-flyout-toggle>
            <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
          </sdx-menu-flyout-toggle>
          <sdx-menu-flyout-content style="width: 600px;">
            <p>
              {{ $t('commons.tag') }}
            </p>
          </sdx-menu-flyout-content>
        </sdx-menu-flyout>
        <sdx-input
            id="tag"
            v-model="tag"

        />
      </div>
    </div>
    -->
    <div class="row margin-bottom-2">
      <div class="col">
        <sdx-select
            id="select-option-child"
            keyboard-behavior="filter"
            label="Column with Recipient Phone Numbers"
            filter-min-length="2"
            @input="placeholderChanged"
        >
          <sdx-select-option
              v-for="placeholder in placeholders"
              :key="placeholder.columnName"
              :value="placeholder.columnName"
              :selected="isSelectedPlaceholder(placeholder.columnName)">
            {{ placeholder.columnName }} (e.g. {{ placeholder.rowValue.substr(0, 40) }})
          </sdx-select-option>

        </sdx-select>
      </div>
    </div>

    <div class="row margin-bottom-2">
      <div class="col">
        <span class="sdx-like-label">Text</span>&nbsp;
        <sdx-menu-flyout>
          <sdx-menu-flyout-toggle>
            <sdx-icon
                icon-name="icon-information-circle"
                sr-hint="Help using placeholders"
            />
          </sdx-menu-flyout-toggle>

          <sdx-menu-flyout-content style="width: 600px" class="sdx-menu-img">
            Drag the placeholders into the text box, which will be replaced while sending the sms with the row values in
            the CSV.<br/>
            Placeholders are the column names in the CSV file.<br/>
          </sdx-menu-flyout-content>
        </sdx-menu-flyout>
        <br/>
        <div v-for="placeholder in placeholders"
             :key="placeholder"
             layout="interaction"
             class="text-align-center divPlaceholder padding-placeholder margin-right-1 margin-bottom-1"
             :draggable="true"
             :title="placeholder.rowValue"
             v-on:dragstart="dragStart">
          {{ placeholder.columnName }}
        </div>
      </div>
      <div class="col">
        <div ref="divTextArea"
             label="Text"
             contenteditable="true"
             class="divTextArea sdx-input padding-2"
             style="white-space: break-spaces;"
             v-on:drop="drop" v-on:dragover="allowDrop"
             @input="loadSmsSplitDetails">
        </div>
      </div>
      <div v-if="campaignTextInfo" class="col-lg-4">
        <p>SMS Parts: <b>{{ campaignTextLength }}</b></p>
      </div>
      <div v-if="campaignTextInfo" class="col-lg-4">
        <p>
          Encoding: <b>{{ campaignTextEncoding }}</b>&nbsp;
          <sdx-menu-flyout v-if="campaignTextEncoding=='UTF16'">
            <sdx-menu-flyout-toggle>
              <sdx-icon
                  icon-name="icon-exclamation-mark-circle"
                  sr-hint="Help using placeholders"
              />
            </sdx-menu-flyout-toggle>
            <sdx-menu-flyout-content style="width: 600px" class="sdx-menu-img">
              UTF-16 encoding needs double of the space for a character.<br/>
              Try to use normal characters.<br/>
              <a href="/unicode-detector" target="_blank">Unicode Detector</a> can help to find special characters.
            </sdx-menu-flyout-content>
          </sdx-menu-flyout>
        </p>
      </div>
    </div>
    <div class="row flex-items-xs-between margin-top-2">
      <div class="col-xs-4">
        <sdx-dialog
            ref="modal-save"
            type="closable-modal"
        >
          <sdx-dialog-toggle>
            <sdx-button
                theme="secondary"
                label="Overview"
                class="sdx-button-child"
            />
          </sdx-dialog-toggle>
          <sdx-dialog-content>
            <div class="custom-dialog-label">There are changes to your campaign draft. <br> Do you want to save or
              discard them?
            </div>
            <sdx-button-group>
              <sdx-button ref="buttonModalSave"
                          label="Save"
                          :disabled="!formIsValid"
                          @click="saveCampaignAndGoToOverview()"></sdx-button>
              <sdx-button ref="buttonModalDiscard"
                          label="Discard"
                          @click="goToOverview()"
                          theme="secondary"></sdx-button>
            </sdx-button-group>
          </sdx-dialog-content>
        </sdx-dialog>
      </div>
      <div class="col-xs-4 text-align-right">
        <sdx-button
            ref="buttonNext"
            label="Next"
            :disabled="!formIsValid"
            class="sdx-button-child margin-left-2"
            @click="saveCampaignAndGoToSummary()"
            loading="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import campaignsService from '@/modules/campaigns/service.js';
import loadingSpinnerService from '@/services/loading-spinner.service';

import {showAlert, showSuccess} from "@/services/notification.service";
import {logger} from "@/services/logger.service";
import unicodeDetectorService from "@/modules/unicodeDetector/service";

const prefixInEditor = "<div contenteditable='false' class='divPlaceholder'><span style='color: #5944C6;'>${</span>"
const prefixPlaceholder = "${"
const postfixInEditor = "<span style='color: #5944C6;'>}</span></div>"
const postfixPlaceholder = "}"

export default {
  data() {
    return {
      formIsValid: false,
      campaignName: undefined,
      campaign: null,
      placeholders: [],
      placeholder4PhoneNumber: "",
      tag: '',
      typingTimer: null,
      campaignTextInfo: false,
      campaignTextLength: "...",
      campaignTextEncoding: "GSM"
    };
  },
  async mounted() {
    loadingSpinnerService.show("campaignEdit");
    await this.loadCampaign()
    await this.loadPlaceholders()
    loadingSpinnerService.hide("campaignEdit");
    this.validateForm()
  },
  methods: {
    async loadCampaign() {
      this.campaign = await campaignsService.getCampaignFromSession();
      logger.debug("campaign: " + JSON.stringify(this.campaign))
      if (this.campaign === null) {
        this.campaign = await campaignsService.getCampaign(campaignsService.getCampaignWebId(), campaignsService.getCampaignId());
        showAlert('Campaign not found. => Go back to Home and select a campaign.')
        this.$router.push("/campaigns/home");
      }
      this.campaignName = this.campaign.name
      this.placeholder4PhoneNumber = this.campaign.placeholder4PhoneNumber
      this.setTemplateText(this.campaign.template);
    },
    async loadPlaceholders() {
      const response = await campaignsService.getPlaceholders(campaignsService.getCampaignWebId(), this.campaign.id);
      this.placeholders = response.data;
      logger.debug(JSON.stringify(this.placeholders))
      if (this.placeholder4PhoneNumber === undefined || this.placeholder4PhoneNumber === null || this.placeholder4PhoneNumber === "") {
        //try to find a column matching the phone number
        const validStrings = ["msisdn", "telefon", "tel", "nummer", "phone", "mobile", "number"];
        for (let i = 0; i < this.placeholders.length; i++) {
          for (let v = 0; v < validStrings.length; v++) {
            if (this.placeholders[i].columnName.toLowerCase().includes(validStrings[v])) {
              this.placeholder4PhoneNumber = this.placeholders[i].columnName
              return
            }
          }
        }
      }
    },
    validateForm() {
      logger.debug("placeholder4PhoneNumber: " + this.placeholder4PhoneNumber)
      this.formIsValid = this.campaignName !== '' && this.placeholder4PhoneNumber !== '' && this.placeholder4PhoneNumber !== undefined && this.getTemplateText() !== ''
    },
    isSelectedPlaceholder(placeholder) {
      return placeholder === this.placeholder4PhoneNumber;
    },
    placeholderChanged() {
      this.placeholder4PhoneNumber = arguments[0].target.value[0];
      this.validateForm()
    },
    async saveCampaignAndGoToSummary() {
      if (await this.saveCampaign()) {
        //TODO Tag must be set to campaign object
        //await campaignsService.setTagToSession(this.tag)
        this.$router.push('/campaigns/summary');
      }
    },
    async saveCampaignAndGoToOverview() {
      if (await this.saveCampaign())
        this.goToOverview();
    },
    goToOverview() {
      this.$router.push('/campaigns');
    },
    getTemplateText() {
      logger.debug("innerHTML: " + this.$refs.divTextArea.innerHTML)
      logger.debug("innerText: " + this.$refs.divTextArea.innerText)
      return this.$refs.divTextArea.innerText;
    },
    setTemplateText(text) {
      this.$refs.divTextArea.innerHTML = (text === undefined || text === null ? "" : text.replaceAll(prefixPlaceholder, prefixInEditor).replaceAll(postfixPlaceholder, postfixInEditor).replaceAll("\n", "<br/>"));
    },
    addPlaceholder(placeholderName) {
      this.$refs.divTextArea.innerHTML += prefixInEditor + placeholderName + postfixInEditor;
      this.validateForm()
    },
    async saveCampaign() {
      var result = false;
      this.$refs.buttonNext.loading = true;
      this.$refs.buttonModalSave.loading = true;
      this.$refs.buttonModalDiscard.loading = true;
      const campaignText = this.getTemplateText()
      try {
        var response=await campaignsService.updateCampaignText(campaignsService.getCampaignWebId(), this.campaign.id, this.campaignName, this.placeholder4PhoneNumber, campaignText);
        if(response.status === 201 || response.status === 200) {
          showSuccess('Campaign saved successfully')
          //load async the campaign in the session
          await campaignsService.reloadCampaignInSession();
          result = true;
        }
        if(response.status === 202) {
          showSuccess('Campaign is still saving. Forward you to Overview.')
          //load async the campaign in the session
          await campaignsService.reloadCampaignInSession();
          this.goToOverview();
        }
      } catch (exception) {
        showAlert("Could not save Campaign! " + exception.response?.data?.detail)
        logger.debug(JSON.stringify(exception));
      }
      this.$refs.buttonNext.loading = false;
      this.$refs.buttonModalSave.loading = false;
      this.$refs.buttonModalDiscard.loading = false;
      logger.debug("saveCampaign=" + result);
      return result
    },
    dragStart(event) {
      event.dataTransfer.setData("Text", event.target.innerText);
    },
    // eslint-disable-next-line no-unused-vars
    dragging(event) {
    },
    allowDrop(event) {
      event.preventDefault();
    },
    drop(event) {
      event.preventDefault();
      var data = event.dataTransfer.getData("Text");
      this.addPlaceholder(data)
    },
    async loadSmsSplitDetails() {
      this.validateForm();
      await this.getSplitsSmsAfterDelay();
    },
    getSplitsSmsAfterDelay() {
      clearTimeout(this.typingTimer);
      this.campaignTextInfo = false;
      this.typingTimer = setTimeout(this.getSplitSms, 2000);
    },
    async getSplitSms() {
      if (this.getTemplateText() !== null || this.getTemplateText() !== '' || this.getTemplateText() !== undefined) {
        let response = await unicodeDetectorService.splitSms(this.getTemplateText());
        this.campaignTextLength = response.data.parts.length;
        this.campaignTextEncoding = response.data.encoding
      }
      this.campaignTextInfo = true;
    }
  }
}
</script>
<style>
.sdx-like-label {
  font-family: TheSans,serif;
  font-size: 16px;
  color: #666666;
}

.divTextArea {
  border: 1px solid black;
  border-radius: 8px;
  background-color: #EEF3F6;
  min-width: 40em;
}

.padding-placeholder {
  padding-bottom: 2px;
  padding-top: 2px;
  padding-left: 4px;
  padding-right: 4px;
}

.colorPlaceholder {
  color: #5944C6;
}

.divPlaceholder {
  border: 1px solid black;
  border-radius: 8px;
  display: inline-block;
  color: white;
  background-color: #5944C6;
}

.custom-dialog-label {
  font-size: 20px;
  color: #001155;
  padding-bottom: 50px;
  font-weight: bold;
}
</style>
